import { Facebook, Instagram, LinkedIn, Twitter } from "@mui/icons-material";
import { EMAIL_URL, PHONE_URL } from "./constants";
import { PRIVACY_POLICY_PDF, TOU_PDF } from "../assets/pdf/Pdfs";

export const helpLinks = [
  {
    label: "Contact Us",
    path: PHONE_URL,
  },
  {
    label: "Customer Support",
    path: EMAIL_URL,
  },
];

export const resourceLinks = [
  {
    label: "Frequently Asked Questions",
    path: "#faqs",
  },
  // {
  //   label: "Resource Center",
  //   path: "",
  // },
  {
    label: "Privacy Policy",
    path: PRIVACY_POLICY_PDF,
    target: "_blank",
  },
  {
    label: "Terms of Use",
    path: TOU_PDF,
    target: "_blank",
  },
];

export const socialLinks = [
  {
    icon: Facebook,
    path: "#",
  },
  {
    icon: Twitter,
    path: "#",
  },
  {
    icon: LinkedIn,
    path: "#",
  },
  {
    icon: Instagram,
    path: "#",
  },
];
